import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27350214"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cookie-checkbox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "cookieCheckbox" }, "Ik stem in met het activeren van marketingcookies", -1))

import { useCookieConsent } from '@/store/useCookieConsent';


export default /*#__PURE__*/_defineComponent({
  __name: 'CookieCheckbox',
  setup(__props) {

const { cookieConsent } = useCookieConsent();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "cookie-checkbox-input",
      id: "cookieCheckbox",
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(cookieConsent) ? (cookieConsent).value = $event : null))
    }, null, 512), [
      [_vModelCheckbox, _unref(cookieConsent)]
    ]),
    _hoisted_2
  ]))
}
}

})